<template>
    <div>
        <div class="choice-box">
            <div>
                <p class="label">{{$t('screening-upload.occupation.work.label')}}</p>

                <div class="container">
                    <label class="choice" :class="{selected: employed === 'no'}">
                        <input type="radio" id="employed_no" value="no" v-model="employed" checked="checked">
                        <span class="radio-button"></span>
                        <label for="employed_no">{{$t('screening-upload.occupation.no')}}</label>
                    </label>
                    <label class="choice" :class="{selected: employed === 'yes'}">
                        <input type="radio" id="employed_yes" value="yes" v-model="employed" checked="checked">
                        <span class="radio-button"></span>
                        <label for="employed_yes">{{$t('screening-upload.occupation.yes')}}</label>
                    </label>
                </div>

                <div class="input-container" v-if="employed === 'yes'">
                    <div>
                        <p class="label">
                            {{$t('tenant-profile.work.company-label')}}
                        </p>
                        <input type="text" v-model="company" :placeholder="$t('tenant-profile.work.company')">
                    </div>
                    <div>
                        <p class="label">
                            {{$t('tenant-profile.work.company-role-label')}}
                        </p>
                        <input type="text" v-model="companyRole" :placeholder="$t('input.placeholder.company-role')">
                    </div>
                    <div>
                        <p class="label">
                            {{ $t('tenant-profile.work.type-label') }}
                        </p>
                        <div class="select-container">
                            <select v-model="employmentType" :readonly="readOnlyFields">
                                <option value disabled>{{ $t('screening-upload.select-job-type.label') }}</option>
                                <option v-for="employmentTypeOption in employmentTypes" :value="employmentTypeOption.id">{{ $t(employmentTypeOption.name) }}</option>
                            </select>
                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 20 11.97">
                                    <path class="fill-purple" d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z" transform="translate(-3241 -2084.03)"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div>
                       <p class="label">
                            {{ $t('tenant-profile.work.start-label') }}
                        </p>
                        <DateTimeInput
                        id="employmentDate"
                        :readonly="readOnlyFields"
                        :time="false"
                        v-on:datetimechange="changeDateEmployment"
                        :value="employmentDate" />
                    </div>
                    <div v-if="usingLinkedInForJob">
                        <button v-on:click="killLinkedInJob" class="purple linkedin">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     width="20px" height="20px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">
                                <path fill="#ffffff" d="M30.7,0H1.3C0.6,0,0,0.6,0,1.3v29.3C0,31.4,0.6,32,1.3,32h29.3c0.7,0,1.3-0.6,1.3-1.3V1.3
                                    C32,0.6,31.4,0,30.7,0z M9.5,27.3H4.7V12h4.8V27.3z M7.1,9.9c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8
                                    C9.9,8.7,8.6,9.9,7.1,9.9z M27.3,27.3h-4.7v-7.4c0-1.8,0-4-2.5-4c-2.5,0-2.8,1.9-2.8,3.9v7.6h-4.7V12H17v2.1h0.1
                                    c0.6-1.2,2.2-2.5,4.5-2.5c4.8,0,5.7,3.2,5.7,7.3V27.3z"/>
                            </svg>
                            {{ $t('screening-upload.linkedin.disconnect.button') }}
                        </button>
                    </div>
                    <div v-if="!usingLinkedInForJob">
                        <p class="label">
                            {{ $t('tenant-profile.work.documentation-label') }}
                        </p>
                        <div v-if="companyFile" class="uploaded-item">
                            <div class="file-name">{{companyFile.file_name}}</div>
                            <div class="delete-item" @click.prevent="deleteFile(companyFile.id)"><img src="/images/SVG/Delete.svg"></div>
                        </div>
                        <div v-else>
                            <vue-dropzone ref="myVueDropzoneEmployed" id="myVueDropzoneEmployed"
                                :options="dropzoneOptions"
                                @vdropzone-success="uploadCompanySuccess"
                                @vdropzone-sending="sendingCompanyFile"
                                @vdropzone-error="customUploadError">
                            </vue-dropzone>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="choice-box">
            <div>
                <p class="label">{{$t('screening-upload.occupation.student.label')}}</p>

                <div class="container">
                    <label class="choice" :class="{selected: student === 'no'}">
                        <input v-on:change="occupationStatusChanged" type="radio" id="study_no" value="no" v-model="student" checked="checked">
                        <span class="radio-button"></span>
                        <label for="study_no">{{$t('screening-upload.occupation.no')}}</label>
                    </label>
                    <label class="choice" :class="{selected: student === 'yes'}">
                        <input v-on:change="occupationStatusChanged" type="radio" id="student_yes" value="yes" v-model="student" checked="checked">
                        <span class="radio-button"></span>
                        <label for="student_yes">{{$t('screening-upload.occupation.yes')}}</label>
                    </label>
                </div>

                <div class="input-container" v-if="student === 'yes'">
                    <div>
                        <p class="label">
                            {{ $t('tenant-profile.study.institution-label') }}
                        </p>
                        <input type="text" v-model="institution"  :placeholder="$t('input.placeholder.institution')">
                    </div>
                    <div>
                        <p class="label">
                            {{ $t('tenant-profile.study.label') }}
                        </p>
                        <input type="text" v-model="study" name="" :placeholder="$t('input.placeholder.study')">
                    </div>
                    <div class="double">
                        <!-- <input :placeholder="$t('input.placeholder.start-date')" v-model="studyStartDate" type="text" onfocus="(this.type='date')"  id="study_date_start"> -->
                        <div class="date-container">
                            <p class="label">
                                {{ $t('tenant-profile.study.start-label') }}
                            </p>
                            <DateTimeInput
                            id="studyStartDate"
                            :readonly="readOnlyFields"
                            :time="false"
                            v-on:datetimechange="changeDateStudyStart"
                            :placeholder="$t('input.placeholder.start-date')"
                            :value="studyStartDate" />
                            <!-- <p class="before-label" v-if="!studyStartDate">{{$t('input.placeholder.start-date')}}</p> -->
                        </div>


                        <!-- <input :placeholder="$t('input.placeholder.end-date')" v-model="studyEndDate" type="text" onfocus="(this.type='date')"  id="study_date_end"> -->
                        <div class="date-container">
                            <p class="label">
                                {{ $t('tenant-profile.study.end-label') }}
                            </p>
                            <DateTimeInput
                            id="studyEndDate"
                            :readonly="readOnlyFields"
                            :time="false"
                            v-on:datetimechange="changeDateStudyEnd"
                            :value="studyEndDate"
                            :placeholder="$t('input.placeholder.end-date')"

                             />
                            <!-- <p class="before-label" v-if="!studyEndDate">{{$t('input.placeholder.end-date')}}</p> -->
                        </div>

                    </div>
                    <div v-if="studentFile" class="uploaded-item">
                        <p class="label">
                            {{ $t('tenant-profile.work.documentation-label') }}
                        </p>
                        <div class="file-name">{{studentFile.file_name}}</div>
                        <div class="delete-item" @click.prevent="deleteFile(studentFile.id)"><img src="/images/SVG/Delete.svg"></div>
                    </div>
                    <div v-else>
                        <p class="label">
                            {{ $t('tenant-profile.work.documentation-label') }}
                        </p>
                        <vue-dropzone ref="myVueDropzoneStudent" id="myVueDropzoneStudent" :options="dropzoneOptions"
                            @vdropzone-success="uploadStudentSuccess"
                            @vdropzone-sending="sendingStudentFiles"
                            @vdropzone-error="customUploadError"></vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
        <div class="seperator"></div>
        <button :disabled="saving" @click.prevent="submitData" class="purple">
            <span v-if="!saving">{{$t('button.continue')}}</span>
            <span v-if="saving">{{ $t('saving') }}</span>
        </button>
        <div v-if="error" class="error-box">
            <div class="triangle"></div>
            <div class="container">
                <SvgIcon icon="warning" />
                <p>{{error}}</p>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import DateTimeInput from '../../../components/DateTimeInput.vue';
    import SvgIcon from '../../../components/Svg.vue';

    export default {
        components: {
            vueDropzone: vue2Dropzone,
            DateTimeInput,
            SvgIcon
        },
        props: ['linkedinjob'],
        data: () => ({
            saving: false,
            linkedInUrl: '',
            dropzoneOptions: {},
            employed: 'no',
            student: 'no',
            companyRole: '',
            company: '',
            employmentDate: '',
            institution: '',
            study: '',
            studyStartDate: '',
            studyEndDate: '',
            studentFile: '',
            companyFile: '',
            submitAllowed: false,
            error: '',
            employmentType: '',
            employmentTypes: {},
            readOnlyFields: false

        }),
        created(){

            this.$root.$on('datetimechange', (value) => {
                if (value.value && typeof value.value == 'string') {
                    this[value.id] = value.value.substr(0, 10);
                }
            });

            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/user/document',
                thumbnailWidth: 150,
                maxFilesize: 10,
                paramName: 'file',
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: true,
                dictDefaultMessage: 'Drop files here to upload or click to browse',
                uploadMultiple: false,
            };
            this.$store.dispatch('fetchStudentFile').then(
                () => {
                    this.studentFile = this.getStudentFile[0];
                }
            );
            this.$store.dispatch('fetchCompanyFile').then(
                () => {
                    this.companyFile = this.getCompanyFile[0];
                }
            );
            this.dropzoneOptions.dictDefaultMessage = this.$t('label.upload.placeholder');
            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/occupation',
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                let data = response.data;
                this.employmentTypes = response.data.employmentTypes;
                this.employed = data.has_job ? 'yes' : 'no';
                this.student = data.is_studying ? 'yes' : 'no';
                this.companyRole = data.company_role;
                this.company = data.company;
                this.employmentDate = data.employed_from;
                this.institution = data.institution;
                this.study = data.study;
                this.studyStartDate = data.study_start_date;
                this.studyEndDate = data.study_expected_end_date;
                this.linkedInUrl = data.linkedin_url;
                this.employmentType = data.job_type;
            });
        },
        computed:{
            usingLinkedInForJob() {
                return this.linkedInUrl;
            },
            allowSubmit(){
                let companyFields = this.employed === 'no';
                let studentFields = this.student === 'no';

                if(!companyFields){
                    companyFields = this.companyFile && this.companyRole.length && this.company.length && this.employmentDate.length
                }

                if(!studentFields){
                    studentFields = this.studentFile && this.institution.length && this.study.length && this.studyStartDate.length && this.studyEndDate.length
                }

                return companyFields && studentFields
            },
            ...mapGetters([
                'getToken',
                'getStudentFile',
                'getCompanyFile'
            ])
        },
        methods:{
            changeDateEmployment(a) {
                this.employmentDate = a.value.substr(0, 10);
            },
            changeDateStudyStart(a) {
                this.studyStartDate = a.value.substr(0, 10);
            },
            changeDateStudyEnd(a) {
                this.studyEndDate = a.value.substr(0, 10);
            },
            customUploadError(data) {
                if(data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                    this.$store.commit('setToken', null)
                    return;
                }

                if (typeof data.xhr == 'undefined') {
                    this.$swal(this.$t('general.unknown-error.label'), [], 'error');
                    return;
                }
                let response = JSON.parse(data.xhr.responseText);
                this.$swal(response.message, [], 'error');
            },
            occupationStatusChanged() {
                if (this.student != 'yes') {
                    this.institution = '';
                    this.study = '';
                    this.studyStartDate = '';
                    this.studyEndDate = '';
                    this.studentFile = '';
                }
                if (this.employed != 'yes') {
                    this.companyRole = '';
                    this.company = '';
                    this.employmentDate = '';
                    this.linkedInUrl = '';
                }
            },
            isFilled() {
                return this.employed == 'yes' || this.student == 'yes';
            },
            killLinkedInJob() {
                this.linkedInUrl = '';
                this.employed = 'no';
                this.companyRole = '';
                this.company = '';
                this.employmentDate = '';
                this.$root.$emit('refreshScreeningStatus');
                this.$root.$emit('killLinkedInJob');
            },
            setEmployment(title, company, startDate, linkedInUrl) {
                this.employed = 'yes';
                this.companyRole = title;
                this.company = company;
                this.employmentDate = startDate;
                this.linkedInUrl = linkedInUrl;
            },
            uploadStudentSuccess(file, response){
                this.studentFile = response;
                this.$root.$emit('refreshScreeningStatus');
            },
            sendingStudentFiles(file, xhr, formData){
                formData.append('type', 'study');
            },
            uploadCompanySuccess(file, response){
                this.companyFile = response;
                this.$root.$emit('refreshScreeningStatus');
            },
            sendingCompanyFile(file, xhr, formData){
                formData.append('type', 'company');
            },
            submitData(){
                this.saving = true;
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/user/occupation',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data:{
                        employed: this.employed === 'yes' ? 1 : 0,
                        student: this.student === 'yes' ? 1 : 0,
                        company_role: this.companyRole,
                        company: this.company,
                        employed_from: this.employmentDate,
                        institution: this.institution,
                        study: this.study,
                        study_start_date: this.studyStartDate,
                        study_expected_end_date: this.studyEndDate,
                        linkedInUrl: this.linkedInUrl,
                        jobType: this.employmentType
                    }
                }).then(e => {
                    this.$store.commit('setSuccessBarMessage', this.$t('screening-upload.occupation-saved.label'));
                    this.saving = false;
                    this.$root.$emit('refreshScreeningStatus');
                    this.$root.$emit('setTenantScreeningTab', 4);
                });
            },
            deleteFile(id){
                axios({
                    method: 'DELETE',
                    url: window.config.apiUrl + 'api/user/document/' + id,
                    cancelToken: window.AuthorizationCancelSource.token,
                }).then(
                    () => {
                        if(id === this.companyFile.id ){
                            this.companyFile = '';
                        }
                        else{
                            this.studentFile = '';
                        }
                        this.$store.dispatch('fetchScreeningStatus');
                        this.$root.$emit('refreshScreeningStatus');
                    }
                );
            }
        }
    }
</script>

<style scoped>

</style>
